import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import Icon from '@ant-design/icons';
import { ReactComponent as ColumnsIconSvg } from '../../assets/columns-icon.svg';

export const ColumnsIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={ColumnsIconSvg} {...props} />;
};
